module.exports = __webpack_public_path__ + "static/media/css3.fbe01551.png";